import { render, staticRenderFns } from "./applyStaffLeaveModal.vue?vue&type=template&id=f35a485a&scoped=true"
import script from "./applyStaffLeaveModal.vue?vue&type=script&lang=js"
export * from "./applyStaffLeaveModal.vue?vue&type=script&lang=js"
import style0 from "./applyStaffLeaveModal.vue?vue&type=style&index=0&id=f35a485a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35a485a",
  null
  
)

export default component.exports